export interface ShopifyConfig {
  storeDomain: string;
  storefrontAccessToken: string;
  apiVersion: string;
}

export interface ShopifyEnvironment {
  SHOPIFY_STORE_DOMAIN: string;
  SHOPIFY_STOREFRONT_TOKEN: string;
  SHOPIFY_API_VERSION: string;
}

export function createShopifyConfig(env: ShopifyEnvironment): ShopifyConfig {
  return {
    storeDomain: env.SHOPIFY_STORE_DOMAIN,
    storefrontAccessToken: env.SHOPIFY_STOREFRONT_TOKEN,
    apiVersion: env.SHOPIFY_API_VERSION,
  };
}
